import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-192a5214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__cnt-trial_version" }
const _hoisted_2 = {
  key: 0,
  class: "trial_version__not-logged-in"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "trial_version__option" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Bitte auswählen:", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "trial_version__option" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "Bitte auswählen:", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 0 }

import { computed, ref, watch } from 'vue';
  import { useStore } from 'vuex';

  import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
  import HttpMethod from 'vue/applications/shared/endpoints/utils/http-method';
  import UniversalEndpoint from 'vue/applications/frontend/endpoints/universal-endpoint';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-trial_version',
  props: {...cntProps()},
  setup(__props) {

  const props = __props;

  const store = useStore();
  const backendData = ref({
    selectedCurriculumId: null,
    selectedRoleId: null,
  });
  const sending = ref<boolean>(false);
  const errors = ref<Array<any>>([]);

  const availableRolesForCurriculum = computed(() => {
    return props
      .contentItem
      .widget_data
      .available_roles
      .filter((role: any) => role.curriculum_id === Number(backendData.value.selectedCurriculumId));
  });

  const selectedCurriculum = computed(() => {
    if (
      !props.contentItem ||
      !props.contentItem.widget_data ||
      !props.contentItem.widget_data.available_curricula
    ) return null;

    return props.contentItem.widget_data.available_curricula.find((curriculum: any) => curriculum.id === backendData.value.selectedCurriculumId);
  });

  const selectedRole = computed(() => {
    if (
      !props.contentItem ||
      !props.contentItem.widget_data ||
      !props.contentItem.widget_data.available_roles
    ) return null;

    return props.contentItem.widget_data.available_roles.find((role: any) => role.id === backendData.value.selectedRoleId)
  });

  const onSelectTrialVersion = async() => {
    if (sending.value) return;

    try {
      sending.value = true;
      errors.value = [];

      const endpoint = new UniversalEndpoint(store);
      // try to book trial version
      const response = await endpoint.request(
        props.contentItem.widget_data.to_trial_version_path,
        HttpMethod.POST,
        {
          selectedCurriculumId: backendData.value.selectedCurriculumId ?? undefined,
          selectedRoleId: backendData.value.selectedRoleId ?? undefined,
        }
      );

      if (response && response.data) {
        if (response.data.redirect) {
          // redirect user to dashboard
          location.href = response.data.redirect;
        } else {
          errors.value.push(response.data.error);
        }
      }
    } finally {
      sending.value = false;
    }
  };

  watch(() => backendData.value.selectedCurriculumId, () => {
    backendData.value.selectedRoleId = null;
  });

  watch(() => props.contentItem.widget_data.available_curricula, () => {
    if (props.contentItem.widget_data.available_curricula.length == 1) {
      backendData.value.selectedCurriculumId = props.contentItem.widget_data.available_curricula[0].id;
    }
  }, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.contentItem)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.contentItem.widget_data.login_path)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(" Sie müssen sich zunächst "),
                _createElementVNode("a", {
                  href: _ctx.contentItem.widget_data.login_path
                }, " einloggen oder registrieren ", 8, _hoisted_3),
                _createTextVNode(". ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_5, [
                    (_ctx.contentItem.widget_data.available_curricula.length > 1)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((backendData.value.selectedCurriculumId) = $event))
                        }, [
                          _hoisted_6,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.widget_data.available_curricula, (curriculum) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: curriculum.id,
                              value: curriculum.id
                            }, _toDisplayString(curriculum.name), 9, _hoisted_7))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, backendData.value.selectedCurriculumId]
                        ])
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, [
                        (selectedCurriculum.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(selectedCurriculum.value.name), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Curriculum")
                            ], 64))
                      ]),
                      (selectedCurriculum.value && selectedCurriculum.value.short_description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(selectedCurriculum.value.short_description), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (backendData.value.selectedCurriculumId)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (availableRolesForCurriculum.value.length == 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Aktuell steht für das Curriculum keine Schnupperversion zur Verfügung. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((backendData.value.selectedRoleId) = $event))
                              }, [
                                _hoisted_12,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRolesForCurriculum.value, (role) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: role.id,
                                    value: role.id
                                  }, _toDisplayString(role.label), 9, _hoisted_13))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, backendData.value.selectedRoleId]
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("strong", null, [
                                  (selectedRole.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(selectedRole.value.label), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("Ich möchte " + _toDisplayString(_ctx.contentItem.widget_data.app_flavor_name) + " nutzen als", 1)
                                      ], 64))
                                ])
                              ])
                            ])
                          ])),
                      (backendData.value.selectedRoleId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (errors.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "booking__error"
                                    }, _toDisplayString(error), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["button", { 'button--disabled': sending.value }]),
                                onClick: onSelectTrialVersion
                              }, [
                                (sending.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" Einen Moment bitte... ")
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(" Zur Schnupperversion ")
                                    ], 64))
                              ], 2)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})